import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { ThirdPillarMetadataComponentAbstract } from '../../metadata-components/third-pillar-metadata/third-pillar-metadata.component.abstract';

@Component({
  selector: 'app-third-pillar-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './third-pillar-metadata-v2.component.html',
})
export class ThirdPillarMetadataV2Component extends ThirdPillarMetadataComponentAbstract {}
